import { render, staticRenderFns } from "./SpoiledRouteSelector.vue?vue&type=template&id=5bcac4ad&scoped=true&"
import script from "./SpoiledRouteSelector.vue?vue&type=script&lang=js&"
export * from "./SpoiledRouteSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcac4ad",
  null
  
)

export default component.exports